import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";

export function getTasks(
    {
        DtaPlanned,
        DtaPlannedFrom,
        DtaPlannedTo,
        IsOpened,
        IsDone,
        Title,
        AssignTo,
        Priority,
        EstimatedTime,
        Limit,
        NextToken,
        forceFetch = false,
        signal = null,
        search = null,
        Status,
        IssueID,
    },
    {FarmID, ClientID, LocalUserID} = {}
) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    let queryParams = {};
    const obj = {...arguments[0], FarmID: _FarmID};
    for (let key of Object.keys(obj)) {
        if (obj[key] !== undefined && obj[key] !== null) {
            queryParams[key] = obj[key];
        }
    }
    return invokeApig({
        ...Paths.getTasks({
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        queryParams: queryParams,
        forceFetch,
        signal,
    });
}
